//export const root = "http://localhost:8094";
export const root = "http://kosztydruku-api.develop.stronazen.pl";
//export const imgHost = 'http://localhost:8089/public';
